import { useState } from 'react';
import cs from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import './style.scss';

export interface TabItemProps {
  key: string;
  value: any;
}

interface IProps {
  /** 初始展示的页面 */
  initialPage?: number;
  /** 当前展示的页面 */
  page: number;
  /** tabs */
  tabs: TabItemProps[];
  /** 子元素 */
  children: React.ReactElement[];
  /** 容器类名 */
  className?: string;
  /** 是否固定在顶部 */
  autoFixed?: boolean;
  /** 切换tab的回调函数 */
  onChange: (tab: TabItemProps, index: number) => void;
}

export const Tabs: React.FC<IProps> = (props) => {
  const { className, children, autoFixed = false, tabs, page, onChange, initialPage = 0 } = props;
  const [curPage, setCurPage] = useState<number>(initialPage || page);

  const [swiperRef, setSwiperRef] = useState<any>(null);

  const onSlideChange = (index: any): void => {
    setCurPage(index);

    if (swiperRef) {
      swiperRef.slideTo(index);
    }

    onChange(tabs[index], index);
  };

  return (
    <div className="tab-swiper-container">
      <div
        className={cs(className, 'tab-container', {
          fixed: autoFixed,
        })}
      >
        <ul className="tab-list">
          {tabs.map((tab, index: number) => (
            <li
              className={cs('tab-item', {
                active: curPage === index,
              })}
              key={index}
              onClick={() => onSlideChange(index)}
            >
              <span>{tab.value}</span>
            </li>
          ))}
        </ul>
        <div
          className={cs('tab-index tab-index-animated')}
          style={{
            width: `${(100 / tabs.length).toFixed(2)}%`,
            transform: `translate3d(${curPage * 100}%, 0px, 0px)`,
            WebkitTransform: `translate3d(${page * 100}%, 0px, 0px)`,
            OTransform: `translate3d(${curPage * 100}%, 0px, 0px)`,
          }}
        >
          <span className="tab-index-bar" />
        </div>
      </div>
      <Swiper
        initialSlide={initialPage || page}
        className="swiper"
        onSwiper={setSwiperRef}
        onSlideChange={(swiper) => onSlideChange(swiper.activeIndex)}
      >
        {children.map((child, index) => (
          <SwiperSlide key={index}>{child}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
